<template>
  <VanCell
    :title="title"
    :placeholder="isDraggingMode ? '' : $t('Message.clickToFill')"
    autosize
    :label-align="isDraggingMode ? 'left' : 'top'"
    :type="isDraggingMode ? 'text' : 'textarea'"
    readonly
    @click="clickOpenRichTextEditor"
    :value-class="isDraggingMode ? 'hidden' : 'hidden'"
  >
    <template #label v-if="!isDraggingMode">
      <div
        class="prose prose-sm same-size"
        v-html="content || $t('Message.clickToFill')"
      ></div>
    </template>
    <template #title v-if="$slots.label && isDraggingMode">
      <slot name="label"></slot>
    </template>
  </VanCell>
</template>

<script lang="ts" setup>
import { AIWriteType } from "@/enums/mateEnums";
import { useGlobalModal } from "@/stores/globalModal";
import { PropType } from "vue";

type FunctionType = (content?: string) => void;

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  content: {
    type: String,
    default: "",
  },
  moduleName: {
    type: String,
    default: "",
  },
  isDraggingMode: {
    type: Boolean,
    default: false,
  },
  aiType: {
    type: String as PropType<AIWriteType>,
    default: AIWriteType.Module,
  },
  options: {
    type: Object,
    default: () => ({}),
  },
  // AI完成回调
  cb: {
    type: Function,
    default: () => {},
  },
  // 1. 信件模式下确认标题之后回调
  cb2: {
    type: Function,
    default: () => {},
  },
});

const modalStore = useGlobalModal();
const clickOpenRichTextEditor = () => {
  if (props.isDraggingMode) return;
  modalStore.openRichEditor({
    title: props.title,
    content: props.content,
    moduleName: props.moduleName,
    aiType: props.aiType,
    callback: props.cb as FunctionType,
    callback2: props.cb2 as FunctionType,
    options: props.options,
  });
};
</script>
